import { render, staticRenderFns } from "./DemoInspectionFormPage.vue?vue&type=template&id=54b0b69a"
import script from "./DemoInspectionFormPage.vue?vue&type=script&lang=js"
export * from "./DemoInspectionFormPage.vue?vue&type=script&lang=js"
import style0 from "./DemoInspectionFormPage.vue?vue&type=style&index=0&id=54b0b69a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports